import { Button, Label, Panel } from 'react-bootstrap';
import { TableWrapper } from '@nkr/views/recipients/donor-pre-select/styles';
import { IAntibodyScreening } from '@nkr/models/index';

interface IProps {
    list: IAntibodyScreening[],
    onViewDetails: (id: number) => void,
    onGetPdfFile: (recipientId: number, orderId: number) => void,
    onGetRawFile: (recipientId: number, orderId: number) => void
}

const Transplanted = (props: IProps) => {
    const renderViewResults = (item: IAntibodyScreening) => {
        if (item.resultsPdfPath != '' && item.resultsRawPath != '') {
            return (
                <><Button bsSize='sm' onClick={() => props.onGetPdfFile(item.recipientId, item.id)}>Download PDF</Button> / <Button bsSize='sm' onClick={() => props.onGetRawFile(item.recipientId, item.id)}>Download CSV</Button></>
            );
        }

        if (item.resultsPdfPath != '' && item.resultsRawPath == '') {
            return (
                <><Button bsSize='sm' onClick={() => props.onGetPdfFile(item.recipientId, item.id)}>Download PDF</Button></>
            );
        }

        if (item.resultsPdfPath == '' && item.resultsRawPath != '') {
            return (
                <><Button bsSize='sm' onClick={() => props.onGetPdfFile(item.recipientId, item.id)}>Download CSV</Button></>
            );
        }
        return <Label style={{ fontSize: '100%' }}>Results Pending</Label>;
    };

    return (
        <Panel style={{ marginTop: 30 }}>
            <Panel.Heading style={{ backgroundColor: '#d9edf7', padding: '7.5px 15px' }}>
                NKR Post Transplant Antibody Results
            </Panel.Heading>
            <Panel.Body>
                <TableWrapper striped condensed>
                    <thead>
                        <tr>
                            <th>Order #</th>
                            <th>Order Date</th>
                            <th>Screening Type</th>
                            <th>Order Status</th>
                            <th>Results Date</th>
                            <th>View Results</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {props.list.map((item, index) => (
                            <tr key={'row' + index}>
                                <td>{item.id}</td>
                                <td>{item.sentDate}</td>
                                <td>{item.is30Day ? "Baseline" : "Annual"}</td>
                                <td>{item.resultsReceivedDate != '' ? "Completed" : <Label style={{ fontSize: '100%' }}>Results Pending</Label>}</td>
                                <td>{item.resultsReceivedDate != '' ? item.resultsReceivedDate : <Label style={{ fontSize: '100%' }}>Results Pending</Label>}</td>
                                <td>{renderViewResults(item)}</td>
                                <td>
                                    <Button bsStyle='primary' bsSize='sm' onClick={() => props.onViewDetails(item.id)}>View Details</Button>
                                </td>
                            </tr>
                        ))}

                        {props.list.length == 0 && (
                            <tr>
                                <td colSpan={7}>No antibody screening results found...</td>
                            </tr>
                        )}
                    </tbody>
                </TableWrapper>
            </Panel.Body>
        </Panel>
    );
}

export default Transplanted;